export async function loadPresets() {
  return {
    live: (await import('../../presets/LivePreset')).default,
    playback: (await import('../../presets/VodPreset')).default,
  };
}
